import { getConfig } from 'config/configuration';

import './toggle.scss';
import classNames from 'classnames';

const { assetsUrl } = getConfig();

interface ToggleProps {
  isToggleOn: boolean;
  isToggleLoading: boolean;
  handleToggleClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  toggleLabel: string;
  toggleLoadingText: string;
  toggleName: string;
  isToggleEnabled?: boolean;
  isToggleError?: string;
}

export const Toggle = ({
  isToggleOn,
  isToggleLoading,
  isToggleError,
  isToggleEnabled = true,
  handleToggleClick,
  toggleLoadingText,
  toggleLabel,
  toggleName
}: ToggleProps): JSX.Element => {
  return (
    <>
      {isToggleLoading ? (
        <div className="loading">
          <img src={assetsUrl + 'website/page-loading.gif'} alt="Loading dots"></img>
          <p className="loading-label">{toggleLoadingText}</p>
        </div>
      ) : (
        <div className={isToggleEnabled ? 'toggle' : 'disabled-toggle'}>
          <div className="switch" id={`${toggleName}-toggle`}>
            <input
              type="checkbox"
              id={toggleName}
              checked={isToggleOn}
              onChange={handleToggleClick}
              disabled={!isToggleEnabled}
              data-testid="settings-toggle"
            />
            <label htmlFor={toggleName}></label>
          </div>
          <p className={classNames(`${toggleName}-label`, 'toggle-label')}>{toggleLabel}</p>
        </div>
      )}
      {isToggleError ? (
        <>
          <div>
            <p className="error-label">An error has occurred. Please try again later.</p>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
